
import { call, put, takeLatest } from "redux-saga/effects";
import { uploadFile } from "shared-utility/store/utils/fileHelper";
import { get } from "lodash";
import {
  defaultReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , callbackSaga
  , subKeySaga
  , fillDictionary
  , handleCallback
} from "shared-utility/store/utils/helpers";

import { ToastSuccess, ToastError } from "../../components/Global/Toasts/Toasty";

// ACTIONS
export const UPLOAD_SPREADSHEET_UPDATE_LOAN_DETAILS_FROM_SPREADSHEET = generateDefaultActions("UPLOAD_SPREADSHEET_UPDATE_LOAN_DETAILS_FROM_SPREADSHEET");
export const updateLoanDetailsFromSpreadsheet = (loanId, file) => makePayload(UPLOAD_SPREADSHEET_UPDATE_LOAN_DETAILS_FROM_SPREADSHEET.value, { loanId, file });
function* updateLoanDetailsFromSpreadsheetSaga(payload) {
  try {
    payload.url = `/loans/updateLoanDetailsFromSpreadsheet/${payload.loanId}`;
    const response = yield call(uploadFile, payload, "POST");
    yield put({ type: UPLOAD_SPREADSHEET_UPDATE_LOAN_DETAILS_FROM_SPREADSHEET.success, payload: response });
  } catch (error) {
    const userFriendlyError = get(error, "response.data.error", "Upload encountered error. Please choose a different file and try again.");
    yield put({ type: UPLOAD_SPREADSHEET_UPDATE_LOAN_DETAILS_FROM_SPREADSHEET.failure, payload: { userFriendlyError, error } });
  }
}

export const UPLOAD_SPREADSHEET_CLEAR_UPLOAD_ERRORS = generateDefaultActions("UPLOAD_SPREADSHEET_CLEAR_UPLOAD_ERRORS");
export const clearUploadErrors = (loanId, file) => makePayload(UPLOAD_SPREADSHEET_CLEAR_UPLOAD_ERRORS.value, { loanId, file });
function* clearUploadErrorsSaga() {
  yield put({ type: UPLOAD_SPREADSHEET_CLEAR_UPLOAD_ERRORS.success });
}

// REDUCER

const initialState = {
  loan: null
};

export function uploadSpreadsheetModalReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case UPLOAD_SPREADSHEET_UPDATE_LOAN_DETAILS_FROM_SPREADSHEET.value:
      return { ...state, showSpinner: true };
    case UPLOAD_SPREADSHEET_UPDATE_LOAN_DETAILS_FROM_SPREADSHEET.success:
      return { ...state, showSpinner: false, uploadErrorMessage: undefined, uploadSuccessful: true, extractedLoanDetails: payload.data };
    case UPLOAD_SPREADSHEET_UPDATE_LOAN_DETAILS_FROM_SPREADSHEET.failure:
      return { ...state, showSpinner: false, uploadErrorMessage: payload.userFriendlyError, uploadSuccessful: false };

    case UPLOAD_SPREADSHEET_CLEAR_UPLOAD_ERRORS.success:
      return { ...state, uploadSuccessful: undefined, extractedLoanDetails: undefined };

      // DEFAULT
    default:
      return state;
  }
}

// SAGA

export function* uploadSpreadsheetModalSaga() {
  yield takeLatest(UPLOAD_SPREADSHEET_UPDATE_LOAN_DETAILS_FROM_SPREADSHEET.value, updateLoanDetailsFromSpreadsheetSaga);
  yield takeLatest(UPLOAD_SPREADSHEET_CLEAR_UPLOAD_ERRORS.value, clearUploadErrorsSaga);
}
